export default __webpack_public_path__ + "static/favicon-8fb27d0db95e1499afa0fbcab7bba8b1.png";